import {
  API_MAIL,
  USER_BROWSER_DETAILS,
  LATEST_TICKET_DETAILS,
  NONE_SELECTED,
} from 'appConstants';
import { ApiRequest } from 'services';
import { SurveyFeedback } from 'types';
import { BrowserUtils } from './BrowserUtils';

export interface Questions {
  [key: string]: string;
}

export interface Answers {
  [key: string]: boolean | number | string | null;
}

const MailUtils = {
  bodyBuild: (questions: Questions, values: Answers) => {
    let body = '';
    Object.keys(questions).forEach((key) => {
      body += `${questions[key]}\n\t`;
      body += values[key] ? `${values[key]}\n\n` : `${NONE_SELECTED}\n\n`;
    });
    return body;
  },

  sendSurvey: async (
    questions: Questions,
    values: Answers,
    subject: string,
    latestTicketId?: string,
  ) => {
    const body = MailUtils.bodyBuild(questions, values);
    const browserDetails = MailUtils.bodyBuild(
      USER_BROWSER_DETAILS,
      BrowserUtils.getBrowserDetails(),
    );
    const ticketDetails = latestTicketId
      ? MailUtils.bodyBuild(LATEST_TICKET_DETAILS, { TicketId: latestTicketId })
      : '';
    /**
     * The max length of subject allowed is 77 characters
     * by the API.
     */
    await ApiRequest.post(API_MAIL, {
      accountId: window.PORTAL_DATA.tenants[0],
      subject: subject.substr(0, 77),
      body: body + browserDetails + ticketDetails,
    });
  },

  setSurveyPayload: (feedback?: SurveyFeedback) => {
    const surveyResponse = !!feedback
      ? {
          contact: feedback.contactVia || NONE_SELECTED,
          rating: feedback.experienceRating || NONE_SELECTED,
          featureRequest: feedback.futureFeatures || NONE_SELECTED,
          issueFeedback: feedback.issuesEncountered || NONE_SELECTED,
        }
      : {};
    return {
      eventType: 'DEFAULT',
      scope: 'USER',
      userAgent: BrowserUtils.getBrowserDetails(),
      username: window.PORTAL_DATA.username,
      domainId: window.PORTAL_DATA.domainId,
      ...(!!feedback && { surveyResponse: surveyResponse }),
    };
  },
};

export { MailUtils };
